import {Box} from '@mui/material';
import {ISelectItem} from './types';
import styles from './style.module.scss';
import {useEffect, useRef, useState} from 'react';

type aurSelectedItemsPanel = {
  selectedItems: ISelectItem[];
  itemDisplay: string | number;
};

const AurSelectedItemsPanel = ({
  selectedItems,
  itemDisplay,
}: aurSelectedItemsPanel) => {
  const [additionalItemCount, setAdditionalItemCount] = useState(0);
  const selectdPanelRef = useRef<HTMLElement>(null);
  const [displayText, setDisplayText] = useState(''); 

    useEffect(() => {
      if (!selectdPanelRef.current) return;
  
      const panelWidth = selectdPanelRef.current.offsetWidth;
      const tempSpan:any = document.createElement('span');
      tempSpan.style.visibility = 'hidden';
      tempSpan.style.whiteSpace = 'nowrap';
      tempSpan.style.position = 'absolute';
      document.body.appendChild(tempSpan);
  
      let text:any = '';
      let visibleItemsCount = 0;
  
      for (let i = 0; i < selectedItems.length; i++) {
        const itemText = selectedItems[i][itemDisplay];
        const nextText = visibleItemsCount === 0 ? itemText : `${text}, ${itemText}`;
        tempSpan.textContent = nextText;
  
        if (tempSpan.offsetWidth <= panelWidth) {
          text = nextText;
          visibleItemsCount++;
        } else {
          // Try to truncate last item's text to fit
          const prefix = visibleItemsCount === 0 ? '' : `${text}, `;
          const original = itemText.toString();
          let end = original.length;
          let truncated = '';
  
          while (end > 0) {
            truncated = original.substring(0, end) + '...';
            tempSpan.textContent = prefix + truncated;
            if (tempSpan.offsetWidth <= panelWidth) {
              text = prefix + truncated;
              visibleItemsCount++;
              break;
            }
            end--;
          }
  
          break;
        }
      }
  
      const remaining = selectedItems.length - visibleItemsCount;
      setDisplayText(text);
      setAdditionalItemCount(remaining > 0 ? remaining : 0);
  
      document.body.removeChild(tempSpan);
    }, [selectedItems, itemDisplay]);
  

  return (
    <Box className={`${styles.aurSelectedItems}`}>
      <Box ref={selectdPanelRef} className={`${styles.aurSelectItemNames}`}>
        {displayText}
      </Box>
      <Box className={`${styles.aurSelectItemCount}`}>
        {additionalItemCount > 0 ? `+${additionalItemCount}` : ''}
      </Box>
    </Box>
  );
};

export default AurSelectedItemsPanel;
